import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Webhooks18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_717)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 17.75C13.8325 17.75 17.75 13.8325 17.75 9C17.75 4.16751 13.8325 0.25 9 0.25C4.16751 0.25 0.25 4.16751 0.25 9C0.25 13.8325 4.16751 17.75 9 17.75ZM9 1.75C7.8226 1.75 7.28731 4.42912 7.11487 5.25H10.8851C10.7127 4.42912 10.1774 1.75 9 1.75ZM5.58527 5.25H2.79391C3.65468 3.82852 4.99005 2.72649 6.5803 2.16361C6.14099 3.00932 5.81386 4.04653 5.58527 5.25ZM5.36596 6.75H2.10591C1.63233 8.20204 1.63233 9.79796 2.10591 11.25H5.36596C5.20847 9.75718 5.20847 8.24282 5.36596 6.75ZM5.58527 12.75H2.79391C3.65468 14.1715 4.99005 15.2735 6.5803 15.8364C6.14099 14.9907 5.81386 13.9535 5.58527 12.75ZM7.11487 12.75H10.8851C10.7127 13.5709 10.1774 16.25 9 16.25C7.8226 16.25 7.28731 13.5709 7.11487 12.75ZM11.125 11.25H6.87496C6.70456 9.75881 6.70456 8.24119 6.87496 6.75H11.125C11.2954 8.24119 11.2954 9.75881 11.125 11.25ZM12.4147 12.75C12.1861 13.9535 11.859 14.9907 11.4197 15.8364C13.01 15.2735 14.3453 14.1715 15.2061 12.75H12.4147ZM15.8941 11.25H12.634C12.7915 9.75718 12.7915 8.24282 12.634 6.75H15.8941C16.3677 8.20204 16.3677 9.79796 15.8941 11.25ZM11.4197 2.16361C13.01 2.72649 14.3453 3.82852 15.2061 5.25H12.4147C12.1861 4.04653 11.859 3.00932 11.4197 2.16361Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_717'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Webhooks18.displayName = 'Webhooks18';
export default Webhooks18;
